import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { combineLatest, from, Observable, of, switchMap } from 'rxjs';
import {
  HomeRouteNames,
  OfferRouteNames,
} from '../../shared/routing.constants';
import { AuthService } from '../auth/auth.service';
import { UserInfoService } from '../user-info.service';

@Injectable({
  providedIn: 'root',
})
export class PublicOfferGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private userInfoService: UserInfoService,

    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const tenderOid = route.params[OfferRouteNames.TenderOid] as string | null; // Extract the tenderOid from route parameters

    return combineLatest([
      this.authService.isAuthenticated(),
      this.userInfoService.isSupplier(),
    ]).pipe(
      switchMap(([isAuthenticated, isSupplier]) => {
        // Show Public View if user is not authenticated
        if (!isAuthenticated) return of(true);

        // Check if user is supplier and redirect to preview page or home page
        const navigationPath = isSupplier
          ? [OfferRouteNames.ModuleBase, OfferRouteNames.Preview, tenderOid]
          : [HomeRouteNames.ModuleBase]; //Go back to home page if user is not supplier

        return from(this.router.navigate(navigationPath));
      })
    );
  }
}
